
import Vue from 'vue';

interface Topic {
  name: string;
  description: string;
}

export default Vue.extend({
  computed: {
    getTopics(): Topic[] {
      return this.$t('trial.showCase.modals.microcertificate.topics') as any as Topic[];
    },
    microcertificateImage(): string {
      return `${process.env.BASE_URL || ''}img/trial/showcase/modals/microcertificate.svg`;
    },
  },
});
